<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->
 
  <!-- DataTales Example -->
  <div class="mt-4">
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800" style="display: inline-block">Manage Trains</h1>
      <button
        type="button"
        class="btn custom-buttons-btn"
        style="float: right"
        [routerLink]="['/component', 'trains', 'trains-add']"
      >
        Add Train
      </button>
    </div> -->
    
        <!-- Commented on 20th April 2026 for the breadcrumb changes -->
<!--  
    <div class="col-6">
      <label for="name" class="form-label">Plant:</label>
      <select
        class="form-select border border-dark"
        name="plantid"
        [(ngModel)]="SelectedId"
        (change)="getSelectedId($event)"
      >
        <option value="">Select Plant</option>
 
        <option *ngFor="let plant of plants" [value]="plant.Id">
          {{ plant.Name }}
        </option>
      </select>
      <div class="col-md-2">
        <label class="form-label">&nbsp;</label>
        <button
          type="button"
          class="btn custom-buttons-btn mt-2"
          (click)="clearFilters()"
          [disabled]="!SelectedId"
          title="Clear selected Plant "
        >
          <i class="fas fa-times"></i> Clear
        </button>
      </div>
    </div> -->

    <div style="min-height: 10px"></div>
    <div *ngIf="showTable">
      <table
        datatable
        [dtOptions]="dtoptions"
        class="table table-bordered"
        width="100%"
        *ngIf="trains && allTrainList.length > 0"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Stages</th>
          </tr>
        </thead>
 
        <tbody>
          <tr *ngFor="let train of allTrainList">
            <td>
              <a class="text-black" (click)="navigate(train.Id)">{{
                train.Name
              }}</a>
            </td>
 
            <td>
              <a class="text-black" (click)="navigate(train.Id)">{{
                train.Stages
              }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
 
 
 